var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "conversation" } },
      [
        _c("ChatMenu", {
          staticClass: "conv-menu",
          on: {
            "add-group": function (value) {
              return _vm.addNewChatChange(value)
            },
          },
        }),
        _vm._v(" "),
        !_vm.addNewChat && !!_vm.selectedChat
          ? _c("ChatViewer", {
              staticClass: "conv-viewer",
              attrs: { "new-group": _vm.addNewChat, visible: _vm.visible },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.addNewChat
          ? _c("addNewChat", {
              attrs: {
                addUserInGroup: _vm.addUserInGroup,
                addNewUserGroupAgents: _vm.addNewUserGroupAgents,
              },
              on: {
                close: function ($event) {
                  _vm.addNewChat = false
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.selectedChat, "meta.chatType") === _vm.chatTypes.THREAD
          ? _c("ThreadSummaryChat", { staticClass: "conv-sum" })
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.selectedChat, "meta.chatType") ===
        _vm.chatTypes.DEPARTMENT
          ? _c("DepartmentSummaryChat", { staticClass: "conv-sum" })
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.selectedChat, "meta.chatType") === _vm.chatTypes.TEAM
          ? _c("TeamSummaryChat", { staticClass: "conv-sum" })
          : _vm._e(),
        _vm._v(" "),
        _vm.$_.get(_vm.selectedChat, "meta.chatType") ===
        _vm.chatTypes.GROUP_THREAD
          ? _c("GroupThreadSummaryChat", {
              staticClass: "conv-sum",
              on: {
                "add-user": function (agents) {
                  return _vm.addNewUserGroup(agents)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }